/**
 * OrbDocCoreConceptsTraitsSLDocScreenView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait OrbDocCoreConceptsTraitsSLDocScreen
 */

import { useOrbDocCoreConceptsTraitsSLDocScreenLogic } from '@/hooks/traits/useOrbDocCoreConceptsTraitsSLDocScreenLogic';
import type { OrbDocCoreConceptsTraitsSLDocScreenConfig } from '@/hooks/traits/useOrbDocCoreConceptsTraitsSLDocScreenLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { OrbDocCoreConceptsTraitsSLDocView as OrbDocCoreConceptsTraitsSLDocViewEntity } from '@app/shared';
import { OrbDocCoreConceptsTraitsSLDocBodyView } from '@/components/traits/OrbDocCoreConceptsTraitsSLDocBodyView';
import { OrbDocCoreConceptsTraitsSLDocFooterView } from '@/components/traits/OrbDocCoreConceptsTraitsSLDocFooterView';
import { OrbDocCoreConceptsTraitsSLDocHeaderView } from '@/components/traits/OrbDocCoreConceptsTraitsSLDocHeaderView';
import { Stack } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface OrbDocCoreConceptsTraitsSLDocScreenViewProps {
  config?: Partial<OrbDocCoreConceptsTraitsSLDocScreenConfig>;
}

export function OrbDocCoreConceptsTraitsSLDocScreenView({ config: propsConfig }: OrbDocCoreConceptsTraitsSLDocScreenViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useOrbDocCoreConceptsTraitsSLDocScreenLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['OrbDocCoreConceptsTraitsSLDocView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="OrbDocCoreConceptsTraitsSL" trait="OrbDocCoreConceptsTraitsSLDocScreen">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="OrbDocCoreConceptsTraitsSLDocScreen">{slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="none"><OrbDocCoreConceptsTraitsSLDocHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocCoreConceptsTraitsSLDocBodyView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocCoreConceptsTraitsSLDocFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default OrbDocCoreConceptsTraitsSLDocScreenView;
